import styled from 'styled-components';
import theme from 'styled-theming';

const tableBorder = theme('name', {
  light: 'rgba(28, 28, 28, 0.14)',
  dark: '#504945',
});

// eslint-disable-next-line import/prefer-default-export
export const NotificationContainer = styled.div`
  .notification-message {
    padding: 16px 0;
    border-bottom: 1px solid ${tableBorder};
    font-size: 14px;
    display: flex;
    flex-direction: column;
  }
  .last-updated {
    font-size: 12px;
    font-weight: 500;
  }
  .no-notifications {
    padding: 170px 20px;
    display: flex;
    justify-content: center;
  }
`;
